var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRatingStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5L10 3V14L5.5 16.5L6.5 11.5L2.5 8L8 7.5Z",
    fill: "#FFC960"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51056 3.08156C9.66024 2.6209 10.3119 2.62091 10.4616 3.08156L11.6434 6.71885C11.8443 7.33688 12.4202 7.75532 13.07 7.75532H16.8945C17.3789 7.75532 17.5803 8.37513 17.1884 8.65983L14.0943 10.9078C13.5686 11.2898 13.3486 11.9668 13.5494 12.5848L14.7313 16.2221C14.8809 16.6828 14.3537 17.0659 13.9618 16.7812L10.8678 14.5332C10.342 14.1512 9.63015 14.1512 9.10442 14.5332L6.01035 16.7812C5.6185 17.0659 5.09126 16.6828 5.24093 16.2221L6.42276 12.5848C6.62357 11.9668 6.40358 11.2898 5.87785 10.9078L2.78379 8.65983C2.39193 8.37513 2.59332 7.75532 3.07768 7.75532H6.90215C7.55199 7.75532 8.12793 7.33688 8.32874 6.71885L9.51056 3.08156Z",
    stroke: "#FFC960"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarHalf);
export default __webpack_public_path__ + "static/media/rating-star-half.702b83ba77718532a9b699cd5b33fc40.svg";
export { ForwardRef as ReactComponent };